<script>
  import * as api from '@/utils/api'

  export default {
    name: 'board-schedule',
    data: () => ({
      boardDate: ''
    }),
    computed: {},
    methods: {},
    async created() {
      const schedule = await api.get('page/board/schedule')
      if (schedule?.[0]?.start) {
        const date = new Date(schedule[0].start)
        this.boardDate = date.toLocaleDateString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          day: '2-digit',
          weekday: 'long',
          year: 'numeric',
          month: 'long'
        })
      }
    }
  }
</script>

<template>
  <v-card id="board" max-width="700px" width="100%">
    <v-card-title class="primary secondary--text text-h6 font-weight-bold"> Board of Trustees </v-card-title>
    <v-card-text class="d-flex flex-column pa-4">
      <v-sheet class="d-flex align-center justify-start">
        <v-icon color="primary" class="mr-2">mdi-calendar</v-icon>
        <p class="text-h6 primary--text font-weight-bold mb-0">SCHEDULE</p>
      </v-sheet>
      <p v-if="boardDate">
        <br />
        <span class="text-body-2 primary--text"> The next board meeting will be held on:</span>
        <br />
        <span class="text-h6 primary--text font-weight-bold"> {{ boardDate }}</span>
      </p>
      <p v-else class="text-body-1 primary--text font-weight-bold">
        The next board meeting has not yet been scheduled.
        <br />
        Please check back soon for further updates.
      </p>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" to="/about/board-of-trustees#members" class="pr-4"> <v-icon left>mdi-account-tie-woman</v-icon> <span class="font-weight-bold">Members</span></v-btn>
      <v-btn color="primary" to="/about/board-of-trustees#documents" class="pr-4"> <v-icon left>mdi-file-document</v-icon><span class="font-weight-bold">Documents</span></v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped></style>
